import {AppBanner} from '../views/extera/banner';

const API_STAGE = 'https://newapi.pezeshket.com';
const API_PRODUCTION = 'https://api.pezeshket.com';
const API_DEVELOP = 'https://devapi.pezeshket.com';
const API_LOCAL = 'http://localhost:60500';
const LOCAL_PORT = '60502';
const WEBSOCKET_STAGE = 'wss://newapi.pezeshket.com/wss/';
const WEBSOCKET_PRODUCTION = 'wss://api.pezeshket.com/wss/';
const WEBSOCKET_DEVELOP = 'wss://devapi.pezeshket.com/wss/';
const WEBSOCKET_LOCAL = 'ws://localhost:60500/wss/';

//@ts-ignore
// eslint-disable-next-line no-undef
global.__STAGE__ = __STAGE__;
//@ts-ignore
// eslint-disable-next-line no-undef
global.__PRODUCTION__ = __PRODUCTION__;

export const iranMode = true;

export const production = Boolean(global.__PRODUCTION__); //process.env.NODE_ENV === "production";
function getBaseUrl() {
  if (global.__STAGE__) {
    return API_STAGE;
  } else if (global.__PRODUCTION__) {
    return API_PRODUCTION;
  } else if (
    typeof window !== 'undefined' &&
    ['localhost', '127.0.0.1'].includes(window.location.hostname) &&
    [LOCAL_PORT].includes(window.location.port)
  ) {
    return API_LOCAL;
  } else {
    return API_DEVELOP;
  }
}
function getWebSocketUrl() {
  if (global.__STAGE__) {
    return WEBSOCKET_STAGE;
  } else if (global.__PRODUCTION__) {
    return WEBSOCKET_PRODUCTION;
  } else if (
    typeof window !== 'undefined' &&
    ['localhost', '127.0.0.1'].includes(window.location.hostname) &&
    [LOCAL_PORT].includes(window.location.port)
  ) {
    return WEBSOCKET_LOCAL;
    // eslint-disable-next-line no-undef
  } else if (__DEV__) {
    return API_DEVELOP;
  } else {
    return WEBSOCKET_DEVELOP;
  }
}

export const application = {
  endpoint: getBaseUrl(),
  tokenPath: '/core/v1/oauth/token',
  webSocketEndpoint: getWebSocketUrl(),
  id: '013c9bad-1f1d-4d69-b17a-d9ba0b19975c',
  version: '1.0.70',
};

export const supportPhoneNumber = '02191002055';

export const mapTileLayerUrlTemplate =
  'https://tile.openstreetmap.org/{z}/{x}/{y}.png'; //"https://i-map.ir/tile/{z}/{x}/{y}.png"

export const googleAnalyticsTrackingCode = 'GTM-TC9QQ54V';

/**
 * WARNING! Update public.firebase-messaging-sw.js too
 */
export const firebaseConfig = {
  apiKey: 'AIzaSyCYtNVeD7rxz80BScyJYLCtS7Hkf_6qXgc',
  authDomain: 'pezeshket-9dd89.firebaseapp.com',
  projectId: 'pezeshket-9dd89',
  storageBucket: 'pezeshket-9dd89.firebasestorage.app',
  messagingSenderId: '645690459850',
  appId: '1:645690459850:web:ad3dcdecbda6741d395633',
  measurementId: 'G-FDN2PZ4JVT',
};

export const fcmPublicVapidKey =
  'BE8P2TyNohVTqfTWfQuPAdIt75OaREB6yJgC1l3Ygkrla6AOzVTHx-qOvPknNWTl3Bn9zNZ3niQkb_dydwAotm4';

export const googletagmanager =
  'BE8P2TyNohVTqfTWfQuPAdIt75OaREB6yJgC1l3Ygkrla6AOzVTHx-qOvPknNWTl3Bn9zNZ3niQkb_dydwAotm4';

export const learnPage = 'https://pezeshket.com/learn';
export const faqPage = 'https://pezeshket.com/pages/faq/';

AppBanner.fetchBannerInfo();

export const fileLimit = {
  avatar: {
    maxSize: 2 * 1024 * 1024,
    accept: ['image/jpeg', 'image/png'],
  },
  headerPhoto: {
    maxSize: 2 * 1024 * 1024,
    accept: ['image/jpeg', 'image/png'],
  },
  becomeAdviser: {
    maxSize: 5 * 1024 * 1024,
    accept: ['image/jpeg', 'image/png', 'application/pdf'],
  },
  adviseSessions: {
    recommendations: {
      maxSize: 5 * 1024 * 1024,
      accept: ['image/jpeg', 'image/png', 'application/pdf'],
    },
    photo: {
      maxSize: 5 * 1024 * 1024,
      accept: ['image/*'],
    },
    file: {
      maxSize: 20 * 1024 * 1024,
      accept: undefined,
    },
  },
  ticket: {
    maxSize: 2000000,
    accept: undefined,
  },
  social: {
    photo: {
      maxSize: 2 * 1000 * 1000,
      accept: ['.jpg', '.jpeg', '.png'],
    },
    video: {
      maxSize: 100 * 1000 * 1000,
      accept: ['.mov', '.wmv', '.avi', '.mp4'],
    },
  },
};

export const hamrahet = {
  application: {
    endpoint: 'https://api.hamrahet.com/core/v1',
    tokenPath: '/oauth/token',
    id: 'c9e9c552-1d9e-4ee5-8e45-cb874d12009b',
  },

  attachmentLimits: {
    maxFileSize: 25 * 1024 * 1024,
    extensions: ['.jpg', '.jpeg', '.png', '.pdf'],
    mimeTypes: ['image/jpeg', 'image/png', 'application/pdf'],
  },
  services: {
    lab: {id: 1, title: 'آزمایشات عمومی'},
    homeVisit: {id: 2, title: 'ویزیت در منزل'},
    corona: {id: 4, title: 'آزمایش کرونا'},
    nurse: {id: 6, title: 'خدمات پرستاری'},
  },
  packages: {
    lab: 5,
    drugStore: 6,
  },
};
